"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataParser_1 = __importDefault(require("../DataParser"));
const utils_1 = require("../../utils");
const helpers_1 = require("js-common/lib/helpers");
class Three9PortalParser extends DataParser_1.default {
    constructor() {
        super();
    }
    /**
     *
     * @param data input from outside source
     * @returns ParsedOutput[]
     */
    parse(data) {
        let parsedData = data.map((item) => {
            let runData;
            let protocolData;
            let optionalData;
            let userData;
            runData = Object.assign({}, item);
            protocolData = item.protocol;
            optionalData = item.optionalData || {};
            userData = {
                username: item.user || null,
                organization: item.organization || null,
                team: item.teamName || null,
            };
            return {
                run: runData,
                protocol: protocolData,
                user: userData,
                optional: optionalData,
            };
        });
        return parsedData;
    }
    /**
     *
     * @param data array of parsed input data
     * @returns FormatOutput[]
     */
    format(data) {
        let formattedData = data.map((item) => {
            let standardCurve = this.formatStandardCurveObject(item);
            let runData = this.formatRunObject(item);
            let protocolData = this.formatProtocolObject(item);
            if (item.protocol.type === "isothermal") {
                runData.duration = `${item.protocol.cycles /
                    (0, utils_1.intervalToSamplesPerMin)(protocolData.isothermalInterval || 0)}:00`;
            }
            return {
                run: runData,
                protocol: protocolData,
                standardCurve,
                user: item.user,
                optional: item.optional,
            };
        });
        return formattedData;
    }
    /**
     *
     * @param item parsed input data
     * @returns FormatRun
     */
    formatRunObject(item) {
        let protocolType = `${item.protocol.protocolType}` || "";
        return {
            id: item.run.id,
            teamId: item.run.teamId,
            parentId: item.run.parentId,
            name: item.run.name,
            timestamp: (0, helpers_1.generateTimeString)(item.run.timestamp),
            duration: item.run.duration,
            sampleType: item.run.type || null,
            location: item.run.locationString || null,
            locationTag: item.run.locationTag || null,
            latitude: item.run.latitude,
            longitude: item.run.longitude,
            version: Object.assign({}, item.run.versions),
            notes: item.run.notes,
            sku: item.run.sku,
            lotNumber: item.run.lotNumber,
            expirationDate: item.run.expirationDate,
            result: this.formatResults(item),
            targets: this.formatRunTargets(item),
            type: `${protocolType.slice(0, 1).toUpperCase()}${protocolType.slice(1)}`,
        };
    }
    /**
     *
     * @param item parsed input data
     * @returns FormatTargets[]
     */
    formatRunTargets(item) {
        let colorOrder = {
            green: 0,
            amber: 1,
            red: 2,
        };
        return item.run.targets
            .map((target) => {
            return {
                name: target.name,
                color: target.emissionColor,
                wellNumber: target.wellNumber,
                sampleName: target.sampleId,
                threshold: target.threshold,
                cq: target.cq,
                baselineData: [...target.baselineData],
                rawData: [...target.rawData],
                sq: target.startingQuantity,
                endRfu: target.endRfu,
                fluorophore: target.fluorophore,
                peak: target.peak,
                meltTemperatures: target.meltTemperatures,
                sourceStartingQuantity: target.sourceStartingQuantity || undefined,
                sampleUnit: target.sampleUnit || undefined,
                sampleAmount: target.sampleAmount || undefined,
                sampleType: target.sampleType || undefined,
            };
        })
            .sort((a, b) => {
            if (a.wellNumber === b.wellNumber) {
                return colorOrder[a.color] - colorOrder[b.color];
            }
            else {
                return a.wellNumber - b.wellNumber;
            }
        });
    }
    /**
     *
     * @param item parsed input data
     * @returns FormatProtocol
     */
    formatProtocolObject(item) {
        return {
            id: item.protocol.id,
            name: item.protocol.name,
            rtTemp: item.protocol.rtTemp,
            rtTime: item.protocol.rtTime,
            firstDenatureTemp: item.protocol.denature,
            firstDenatureTime: item.protocol.firstDenatureTime,
            cycleNums: item.protocol.cycles,
            denatureTemp: item.protocol.denature,
            denatureTime: item.protocol.denatureTime,
            annealTemp: item.protocol.anneal,
            annealTime: item.protocol.annealTime,
            extensionTemp: item.protocol.extensionTemp,
            extensionTime: item.protocol.extensionTime,
            isothermalTemp: item.protocol.isothermalTemp || null,
            isothermalInterval: item.protocol.isothermalInterval || null,
            meltDuration: item.protocol.meltDuration || null,
            meltTempStart: item.protocol.meltTempStart || null,
            meltTempFinal: item.protocol.meltTempFinal || null,
            meltIncrement: item.protocol.meltIncrement || null,
        };
    }
    /**
     *
     * @param item parsed input data
     * @returns FormatStandardCurve
     */
    formatStandardCurveObject(item) {
        const colors = ["green", "amber", "red"];
        let standardCurve = {};
        colors.forEach((color) => {
            let result = {
                slopes: null,
                yIntercepts: null,
                efficiencies: null,
                rSquares: null,
            };
            if (item.protocol.slope)
                result.slopes = item.protocol.slope[color];
            if (item.protocol.intercept)
                result.yIntercepts = item.protocol.intercept[color];
            if (item.protocol.efficiency)
                result.efficiencies = item.protocol.efficiency[color];
            if (item.protocol.rSquared)
                result.rSquares = item.protocol.rSquared[color];
            standardCurve[color] = result;
        });
        return standardCurve;
    }
    /**
     *
     */
    formatResults(item) {
        let colorOrder = {
            green: 0,
            amber: 1,
            red: 2,
        };
        if (item.run.result) {
            return Object.assign(Object.assign({}, item.run.result), { targetResults: item.run.result.targetResults.sort((a, b) => {
                    if (a.well === b.well) {
                        return colorOrder[a.emissionColor] - colorOrder[b.emissionColor];
                    }
                    else {
                        return a.well - b.well;
                    }
                }) });
        }
        else {
            return null;
        }
    }
}
exports.default = Three9PortalParser;
